import React from 'react';
import { motion } from 'framer-motion';
import { Accordion } from './ui/Accordion';
const faqData = [{
  title: '¿Cómo recibo el Profes de Telas Resuelto después de comprar?',
  content: 'Inmediatamente después de confirmar el pago recibís un email con el acceso a todos los PDFs. En menos de 5 minutos tenés todo disponible para descargar y usar.'
}, {
  title: '¿Sirve para profes con poca experiencia o solo para las avanzadas?',
  content: 'Sirve para todos los niveles de experiencia docente. El Tomo 1 empieza desde los fundamentos y los tomos 2, 3 y 4 van escalando en complejidad. Si sos nueva, arrancás por el principio. Si ya tenés experiencia, usás lo que necesitás.'
}, {
  title: '¿Es editable? ¿Puedo modificarlo?',
  content: 'Los PDFs están pensados para ser usados tal como están. No son editables, pero toda la información está lista para aplicar directamente sin necesidad de modificar nada.'
}, {
  title: '¿Los 6 bonos están en las dos ofertas?',
  content: 'Sí. Los 6 bonos estratégicos están incluidos tanto en la oferta de $19.990 como en la oferta de $27.990. El Pack Élite agrega los dos upsell adicionales sobre esa base.'
}, {
  title: '¿Sirve si doy clases individuales o solo para grupos?',
  content: 'Sirve para los dos formatos. El sistema está diseñado para adaptarse tanto a clases grupales como a clases individuales o semiprivadas.'
}, {
  title: '¿Sirve si tengo alumnas de distintos niveles al mismo tiempo?',
  content: 'Sí, especialmente. El Bono 2 con el diccionario de figuras y las variaciones por nivel del sistema te permiten dar la misma clase con adaptaciones para cada alumna sin que la clase sea un caos.'
}, {
  title: '¿Qué diferencia tiene con otros materiales de telas?',
  content: 'Es el único sistema que cubre el ciclo completo del docente: formación técnica, planificación por niveles, corrección, seguridad, gestión y marketing. No son ejercicios sueltos ni videos. Es un sistema estructurado listo para usar.'
}, {
  title: '¿Por qué elegir el Pack Élite y no el estándar?',
  content: 'El Pack Élite agrega el Kit Emprendedora Fit y el Programa Anual de 12 meses, que resuelven el siguiente nivel del problema: no solo enseñar bien, sino llenar el espacio, cobrar mejor y tener todo el año organizado sin decidir nada semana a semana.'
}, {
  title: '¿Tiene garantía real?',
  content: 'Sí, total. 7 días, devolución del 100%, sin preguntas ni formularios. Podés usar el material durante esos 7 días y si no es lo que esperabas te devolvemos todo.'
}];
export const FAQ: React.FC = () => {
  return <section className="py-10 md:py-20 bg-background" data-id="element-101">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-102">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-6 md:mb-12" data-id="element-103">
          <h2 className="text-2xl md:text-4xl font-bold font-serif text-gray-900 mb-2 md:mb-4" data-id="element-104">
            Preguntas Frecuentes
          </h2>
        </motion.div>

        <Accordion items={faqData} data-id="element-105" />
      </div>
    </section>;
};